import React from 'react'

import { isEmpty } from 'ramda'

import { AccordionRow, Button, Div, H4, Tag } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'
import { driftAPI } from '@driftt/traffic-control'

import config from 'config'

import { DNSSettings } from './DNSSettings'

import './style.css'

const StatusTag = (isVerified) => {
  return isVerified ? (
    <Tag
      text="Verified"
      backgroundColor="var(--color-p2-3)"
      textColor="var(--color-p2-6)"
    />
  ) : (
    <Tag
      text="Not verified"
      backgroundColor="var(--color-s3-2)"
      textColor="var(--color-s3-6)"
    />
  )
}

const InvalidDomainRow = ({ domain }) => (
  <Div className="domain-invalid-row">
    <Div className="domain-invalid-row--header-text">
      <Div className="domain-invalid-row--text-container">
        <H4>{domain}</H4>
        <Div className="domain-invalid-row--description-text">
          We are unable to create DNS records for this domain
        </Div>
      </Div>
      <Div className="domain-invalid-row--warning-elements">
        <Tag
          backgroundColor="var(--color-s2-3)"
          text={
            <Icon
              className="domain-status-tag-warning-icon"
              name="warning-triangle"
            />
          }
        />
        <Button
          onClick={() =>
            driftAPI.startInteraction({
              interactionId: config.DRIFT_EMAIL_SUPPORT_INTERACTION_ID,
            })
          }
          className="domain-invalid-row--warning-button"
          type="tertiary"
        >
          Contact support
        </Button>
      </Div>
    </Div>
  </Div>
)

const Domain = ({ allSendingDomains, sendingDomain, setSendingDomains }) => {
  const { id, domain, status, sparkPostDkim, sendgridDkim } = sendingDomain

  const isVerified = status === 'VERIFIED'
  const isInvalid =
    (!sparkPostDkim || isEmpty(sparkPostDkim)) &&
    (!sendgridDkim || isEmpty(sendgridDkim))

  const title = (
    <Div className="domain-accordion-row-title">
      {domain} {StatusTag(isVerified)}{' '}
    </Div>
  )

  if (isInvalid) return <InvalidDomainRow domain={domain} />

  return (
    <AccordionRow key={id} title={title} actionType="dropdown">
      <DNSSettings
        allSendingDomains={allSendingDomains}
        setSendingDomains={setSendingDomains}
        sendingDomain={sendingDomain}
      />
    </AccordionRow>
  )
}

export default Domain
